<template>
  <UiContainer tag="section">
    <header class="mb-4">
      <UiTitle severity="h3"> Выберите время </UiTitle>
    </header>
    <template v-if="!loading && value">
      <LookEventSeancesPreview
        :value="value.seances"
        :value-count="value.eventSeancesCount"
        @open-timetable="emit('openTimetable', value.id, $event)"
      />
    </template>
    <template v-else>
      <EventTimetablePreviewSkeleton />
    </template>
  </UiContainer>
</template>

<script lang="ts" setup>
import { LookEventSeancesPreview } from '@/4_features/Event'
import type { Event } from '@/5_entities/Event'
import type { TimetableFilterMode } from '@/6_shared/model'
import { UiTitle, UiContainer } from '@/6_shared/ui'
import EventTimetablePreviewSkeleton from './EventTimetablePreviewSkeleton.vue'

type PropType = {
  value?: Event
  loading?: boolean
}
type EmitType = {
  (e: 'openTimetable', eventId: Event['id'], mode: TimetableFilterMode): void
}
withDefaults(defineProps<PropType>(), {
  value: undefined,
  loading: false
})
const emit = defineEmits<EmitType>()
</script>
